import BaseComponent from "@js/components/base_component.jsx";

// ECharts, assembled from just the pieces the home screen's two bar charts
// need. The whole library is several megabytes and would land in the shared
// bundle every Engine UI page loads; this build is a fraction of it. Anything
// a future chart needs — another series type, a legend, a zoom control — has
// to be registered here too, or ECharts silently ignores that part of the
// option.
import * as echarts from "echarts/core";
import { BarChart, LineChart } from "echarts/charts";
import { GridComponent, TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([ BarChart, LineChart, GridComponent, TooltipComponent, CanvasRenderer ]);

// A thin React wrapper around an ECharts instance: creates it on mount,
// replaces the whole option when it changes, keeps it sized to its container,
// and disposes it on unmount.
//
// The container has to be measurable when echarts.init runs, so a chart that
// is hidden (the table view is showing) must be unmounted rather than merely
// display:none'd — see ChartPanel.
class EChart extends BaseComponent {

  constructor(props) {
    super(props);

    this._el       = null;
    this._chart    = null;
    this._onResize = null;
  }

  componentDidMount() {
    if (this._el && this.props.option) {
      this._chart = echarts.init(this._el);
      this._chart.setOption(this.props.option);
    }

    this._onResize = () => { if (this._chart) this._chart.resize(); };
    window.addEventListener("resize", this._onResize);
  }

  componentDidUpdate(prevProps) {
    if (!this._chart) return;

    if (JSON.stringify(prevProps.option) !== JSON.stringify(this.props.option)) {
      this._chart.setOption(this.props.option, true); // notMerge: full replace
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._onResize);

    if (this._chart) {
      this._chart.dispose();
      this._chart = null;
    }
  }

  render() {
    return (
      <div
        ref={el => this._el = el}
        style={{ width: "100%", height: this.props.height || 240 }}
      />
    );
  }

}

export default EChart;
